const translations = {
  en: {
    "since last update": "since last update",
    "No change": "No change",
    "See your full score": "See your full score",
    Control: "Control",
    Safety: "Safety",
    Growth: "Growth",
  },
  "zh-tw": {
    "since last update": "since last update",
    "No change": "No change",
    "See your full score": "See your full score",
    Control: "Control",
    Safety: "Safety",
    Growth: "Growth",
  },
};

export default translations;
